/* 夏侯淵傳・第 3 章：救祁山（214 年）
 * 東邊是陳倉（出發地），往西是夾在山崖之間的陳倉狹道；過了狹道是渭水，西岸是馬超迎戰的地方；最西是被圍的祁山。 */
export const CHENCANG = [9300, 2500], ENVOY = [9500, 3100], RIVER_X = 4300, WEI = [3700, 2250], QISHAN = [1200, 2000];
export const PATH = [[8900, 2500], [8000, 2450], [6900, 2650], [5700, 2400], [4700, 2300], [3700, 2250], [2600, 2100], [1600, 2000]];
export const AMBUSH = [[7500, 2500], [6300, 2550], [5200, 2350]];
export default {
  id: 'xiahouyuan_qishan', name: '陳倉狹道・祁山', W: 10000, H: 4400, seed: 214,
  bases: [CHENCANG, QISHAN],
  roads: [{ pts: [CHENCANG, ...PATH, QISHAN], w: 130 }],
  rivers: [{ pts: [[RIVER_X - 200, 100], [RIVER_X, 1400], [RIVER_X + 100, 2300], [RIVER_X - 100, 3300], [RIVER_X + 50, 4500]], hw: 110, fords: [] }],
  // 狹道：路的兩側都是山崖
  rocks: [[7600, 1700, 900, 420], [7600, 3400, 900, 460], [5900, 1650, 800, 450], [5900, 3300, 800, 420], [2400, 900, 520, 240], [2600, 3500, 520, 240], [9300, 1200, 420, 200]],
  woods: 0.5,
  sight: 0.8,
  clearings: [[CHENCANG[0], CHENCANG[1], 500], [WEI[0], WEI[1], 600], [QISHAN[0], QISHAN[1], 600], [ENVOY[0], ENVOY[1], 200]],
  tents: [{ x: CHENCANG[0], y: CHENCANG[1], n: 6, r: 380, chief: true, col: '#3b5a99', flag: '夏' }, { x: QISHAN[0], y: QISHAN[1], n: 5, r: 340, col: '#3b5a99', flag: '姜' }, { x: WEI[0] - 300, y: WEI[1] - 100, n: 4, r: 300, col: '#6a3a2a', flag: '馬' }],
  grass: [[3000, 2600, 220, 100], [2000, 1600, 220, 100]],
};
